<script setup lang="ts">
  import { provide, onMounted } from 'vue';
  import useTheme from '@/shared/lib/use/useTheme';

  const { currentTheme, setTheme } = useTheme();

  provide('theme', {
    currentTheme,
    setTheme,
  });

  onMounted(() => {
    const savedTheme = localStorage.getItem('userTheme');
    if (savedTheme) {
      const theme = JSON.parse(savedTheme);
      setTheme(theme);
    }
  });
</script>

<template>
  <div>
    <slot />
  </div>
</template>
